import type { RouteObject } from "react-router-dom";

export const dashboardPath = "/dashboard";

export const dashboardRoute: RouteObject = {
    path: dashboardPath,
    lazy: async () => {
        const { DashboardPage } = await import("@/features/dashboard/page");
        return { Component: DashboardPage };
    },
};
